import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Intent, Card, Button, FormGroup, Checkbox } from '@blueprintjs/core';

import { signDocuments } from '@f/services/user/user.actions';
import { signIn } from '@f/services/authentication/authentication.actions';
import { CenteredContainer } from '@f/components/shared/centered-container/CenteredContainer';

import cls from './SignDocumentsPage.module.css';

class SignDocumentsPage extends Component {
  static propTypes = {
    user: PropTypes.object,
    isProcessing: PropTypes.bool,
    error: PropTypes.object,
    signDocuments: PropTypes.func,
    signIn: PropTypes.func,
  };

  state = {
    signedDocuments: {},
  };

  hasSignedAllDocuments = user => {
    return user && user.unsignedDocuments.length === 0;
  };

  hasCheckedAllDocuments = () => {
    const { user } = this.props;
    const { signedDocuments } = this.state;

    if (!user) {
      return false;
    }

    const signedDocumentCount = Object.values(signedDocuments).filter(Boolean).length;

    return signedDocumentCount === user.unsignedDocuments.length;
  };

  onTermsCheckboxChange = document => e => {
    const { signedDocuments } = this.state;

    this.setState({
      signedDocuments: {
        ...signedDocuments,
        [document.name]: e.target.checked,
      },
    });
  };

  onSubmit = async e => {
    e.preventDefault();
    const { user } = this.props;
    const { signedDocuments } = this.state;

    const signedDocumentNames = Object.entries(signedDocuments).flatMap(([name, checked]) => (!checked ? [] : [name]));
    const documents = user.unsignedDocuments.filter(document => signedDocumentNames.includes(document.name));

    await this.props.signDocuments(documents);
    await this.props.signIn();
  };

  render() {
    const { user, isProcessing } = this.props;

    if (!user) {
      return null;
    }

    if (this.hasSignedAllDocuments(user)) {
      return <Redirect to="/dashboard" />;
    }

    const documents = user.unsignedDocuments;

    return (
      <CenteredContainer>
        <Card className={cx(cls.w30r, cls.p2r)}>
          <h4 className={cls.cardTitle}>Some documents has been updated</h4>
          <p className={cls.mb2r}>
            {'Please read the following updated documents carefully. '}
            {'It is necessary to accept these documents before continuing to Molecule.one.'}
          </p>

          <form onSubmit={this.onSubmit}>
            <FormGroup className={cls.mb2r} intent={Intent.NONE}>
              {documents.map(document => (
                <Checkbox
                  required={document.required}
                  onChange={this.onTermsCheckboxChange(document)}
                  key={document.url}
                >
                  <span>
                    {'I accept the '}
                    <a href={document.url} target="_blank" rel="noopener noreferrer">
                      {document.name}
                    </a>
                    {'. '}
                  </span>

                  {!document.required && <span className={cls.optionalLabel}>(optional)</span>}
                </Checkbox>
              ))}
            </FormGroup>

            <Button
              large
              type="submit"
              intent={Intent.PRIMARY}
              disabled={isProcessing || !this.hasCheckedAllDocuments()}
              loading={isProcessing}
              text="Accept documents"
            />
          </form>
        </Card>
      </CenteredContainer>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      user: state.authentication.user,
      isProcessing: state.user.document.sign.processing > 0,
      error: state.user.document.sign.error,
    }),
    { signDocuments, signIn }
  )(SignDocumentsPage)
);
